// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-roles-and-responsibilities.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-roles-and-responsibilities',
  title: 'Define AI roles, responsibilities and concern-reporting mechanism',
  description:
    'Confirm that roles and responsibilities for the AI management system are defined, allocated and communicated (ISO/IEC 42001 Cl. 5.3, Annex A.3.2), and that personnel and external stakeholders have a mechanism to raise concerns about AI systems with protection against retaliation (Annex A.3.3). Review the AI roles-and-responsibilities record, RACI chart if maintained, and evidence that the concern-reporting channel is published and has been exercised at least on a test basis.',
  category: 'governance',
  scfIds: ['SCF-AIG-002'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'AI roles-and-responsibilities document is published',
    },
    { type: 'document-approved', description: 'Document has been approved' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
